export default class ConfigConnection {
  // Prod API
  // apiInstance = "http://localhost:3000/";
  // Dev API
  apiInstance = process.env.VUE_APP_API_URL || "https://socialdoctor.mx:4455/";
}
